var map = {
	".": 8305,
	"./": 8305,
	"./about.md": 6696,
	"./avatar.png": 5581,
	"./index": 8305,
	"./index.js": 8305,
	"./intro.md": 9937,
	"./main": 7405,
	"./main.js": 7405,
	"./projects": 1145,
	"./projects.js": 1145,
	"./style/grid12.css": 4243,
	"./style/layout-home.css": 7455,
	"./style/layout-project.css": 2501,
	"./style/mdstyle.css": 7415,
	"./style/normalize.css": 3084,
	"./style/style.css": 86
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 407;